<div class="row pt-4 mb-5">
    <div class="col-md-6">
        <div class="card p-3 mb-4">
            <form role="form" [formGroup]="formCadastroCandidato" (ngSubmit)="validaCurriculo()">
                <div *ngIf="carregandoCandidatosEdit == true" class="carregando">
                    <div class="c-loader"></div>
                </div>
                <h5 *ngIf="!editandoCandidato" class="mb-0">Cadastro de candidato / resposta</h5>
                <h5 *ngIf="editandoCandidato" class="mb-0">Edição de candidato / resposta</h5>
                <hr>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <strong for="exampleInputPassword1">Nome completo / Título*</strong>
                            <angular-editor id="nome" formControlName="nome" [config]="editorConfig"></angular-editor>
                            <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                *ngIf="!formCadastroCandidato.get('nome').valid && ( formCadastroCandidato.get('nome').touched || isSubmit )">
                                    <small>Campo  nome/titulo é obrigatório!</small>
                            </span>  
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5">
                        <div class="form-group">
                            <strong for="exampleInputPassword1">CPF</strong>
                            <input type="text" min="1" class="form-control"
                                formControlName="cpf" mask="000.000.000-00"
                                placeholder="999.999.999-99">
                            <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                *ngIf="!formCadastroCandidato.get('cpf').valid && ( formCadastroCandidato.get('cpf').touched || isSubmit )">
                                <small>CPF inválido!</small>
                            </span>
                        </div>
                    </div>
                    <div class="col-7">
                        <div class="form-group">
                            <strong>Cargo / Pauta*</strong>
                            <select class="form-control" formControlName="cargo">
                                <option value="">Selecione</option>
                                <option *ngFor="let c of listaCargos"
                                    value="{{c.id}}">
                                    {{c.nome}}
                                </option>
                            </select>
                            <!-- <table class="table-bordered">
                                <tr *ngFor="let c of listaCargos">
                                    <td>{{c.nome}}</td>
                                </tr>
                            </table> -->
                            <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                                *ngIf="!formCadastroCandidato.get('cargo').valid && ( formCadastroCandidato.get('cargo').touched || isSubmit )">
                            <small>Campo cargo / pauta é obrigatório!</small>
                        </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4" *ngIf="imageSrc">
                        <div class="form-group">
                            <label></label>
                            <img [src]="imageSrc"
                                style="max-width:100%;max-height:100%" />
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="form-group">
                            <strong>Foto</strong>
                            <input (click)="fixAlterarImg(this)" class="form-control
                                ext-input p-8" id="imageCandidato" name="imageUrl"
                                type="file" accept="image/*"
                                (change)="handleInputChange($event)" />
                        </div>
                    </div>
                </div>
                <div class="mb-3">
                    <strong>Currículo / Descrição</strong>
                    <angular-editor id="curriculum" formControlName="curriculum"
                        [config]="editorConfig"></angular-editor>
                      <!--  <span class="alert alert-danger mr-2 ml-2 mt-n1 p-1"
                            *ngIf="!formCadastroCandidato.get('curriculum').valid && ( formCadastroCandidato.get('curriculum').touched || isSubmit )">
                            <small>Campo currículo/descrição é obrigatório!</small>
                        </span>  -->
                </div>
                <button *ngIf="!editandoCandidato" type="submit" class="btn
                    btn-success btn-custom">Salvar</button>
                <button *ngIf="editandoCandidato" type="submit" class="btn
                    btn-success btn-custom">Salvar Edição</button>
                <button *ngIf="editandoCandidato" (click)="cancelarEdicao()"
                    type="button" class="btn btn-light btn-custom mr-2">Cancelar edição</button>
                    <div>
                    <div class="col-12 col-md-4">
                        <div class="row m-0">
                            <strong class="m-">Voto justificavel *</strong>
                            <select class="form-control"  formControlName="votoJustificavel">
                                <option value="true">Sim</option>
                                <option value="false" selected>Não</option>
                            </select>
                        </div>
                    </div>
                    <div>
                        <br>
                    </div>
                    <div class="mb-3"  *ngIf="formCadastroCandidato.get('votoJustificavel').value == 'true'">
                            <div class="form-group">
                            <strong class="m-">Parâmetro Justificativa *</strong>
                            <textarea class="form-control" formControlName="parametroJustificativa" style="height: 150px; min-height: 0px;"></textarea>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="col-md-6">
        <div class="card p-3">
            <div *ngIf="carregandoCandidatos == true" class="carregando">
                <div class="c-loader"></div>
            </div>
            <div class="d-flex flex-row align-items-center">
                <h5 class="mb-0 mr-auto">Candidatos / Respotas cadastradas</h5>
                <div class="justify-items-end">
                    <button class="btn mr-2 btn-light ml-auto"
                        (click)="baixarTemplate()" pTooltip="Baixar modelo de
                        importação">
                        <i class="fas fa-file-download"></i>
                    </button>
                    <button class="btn btn-success ml-auto" data-toggle="modal"
                        data-target="#modalcandidato" pTooltip="Importar arquivo
                        de candidatos / pautas">
                        <i class="fas fa-file-csv"></i>
                    </button>
                </div>
            </div>
            <hr>
            <div>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th style="width: 48%;">Nome / Título</th>
                            <th class="text-center">Cargo / Pauta</th>
                            <th class="text-center" colspan="2">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let candidato of listaCandidatos">
                            <td [innerHTML]="candidato.nome"></td>
                            <td class="text-center">{{candidato.cargo.nome}}</td>
                            <td class="text-center">
                                <button class="btn p-1 act"
                                    data-toggle="tooltip" title="editar"
                                    (click)="editarCandidato(candidato)">
                                    <i class="fas fa-edit fa-sm"></i>
                                </button>
                            </td>
                            <td class="text-center">
                                <button class="btn p-1 act"
                                    data-toggle="tooltip" title="excluir"
                                    (click)="excluirCandidato(candidato.id)"
                                    [disabled]="btOff">
                                    <i class="fas fa-trash fa-xs"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>  
    <div class="modal fade" id="myModal2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h2 class="modal-title text-center" id="exampleModalLabel">Atenção!</h2>
                    <button type="button"  class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <h4>O currículum/descrição do candidato/resposta não foi informado, deseja prosseguir com o cadastro?</h4>
                </div>
                <div class="modal-footer text-center" >
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="prosseguirSemCurriculum()">
                      Sim
                    </button>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="pararSubmit()">
                        Não
                     </button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="modalcandidato" #content>
    <cadastro-massa-candidato [listaCargos]="listaCargos"></cadastro-massa-candidato>
</div>